import React from 'react';
import PropTypes from 'prop-types';
import dateFnsFormat from 'date-fns/format';
import dateFnsParse from 'date-fns/parse';
import { injectIntl } from 'react-intl';
import { DateUtils } from 'react-day-picker';
import Icon from '../Icon';
import DayPickerInput from '../DayPickerInput';

import './styles.css';

class IntlDatePicker extends React.PureComponent {
  static propTypes = {
    intl: PropTypes.shape({
      formatDate: PropTypes.func.isRequired,
    }).isRequired,
    date: PropTypes.instanceOf(Date),
    dateFormat: PropTypes.string,
    onDayChange: PropTypes.func.isRequired,
  };

  constructor(props, context) {
    super(props, context);

    const date = new Date();
    date.setDate(14);
    const months = [];
    for (let i = 0; i < 12; i += 1) {
      date.setMonth(i);
      months.push(this.props.intl.formatDate(date, { month: 'long' }));
    }

    const weekdaysShort = [];
    const weekdaysLong = [];
    date.setDate(date.getDate() - date.getDay());
    for (let i = 0; i < 7; i += 1) {
      weekdaysShort.push(this.props.intl.formatDate(date, { weekday: 'short' }));
      weekdaysLong.push(this.props.intl.formatDate(date, { weekday: 'long' }));
      date.setDate(date.getDate() + 1);
    }

    this.state = { months, weekdaysShort, weekdaysLong };
  }

  getFirstDayOfWeek = (locale) => 0;

  getMonths = (locale) => this.state.months;

  formatDay = (d, locale = 'en') => this.props.intl.formatDate(d, { day: 'numeric', month: 'long', year: 'numeric' });

  formatMonthTitle = (d, locale) => this.props.intl.formatDate(d, { month: 'long', year: 'numeric' });

  formatWeekdayShort = (index, locale = 'en') => this.state.weekdaysShort[index];

  formatWeekdayLong = (index, locale = 'en') => this.state.weekdaysLong[index];

  parseDate = (str, format, locale = 'en') => {
    const parsed = dateFnsParse(str, format, new Date(), { locale });
    return DateUtils.isDate(parsed) ? parsed : undefined;
  }

  formatDate = (date, format, locale) => dateFnsFormat(date, format, { locale });

  iconClick = (event) => {
    event.persist();
    event.target.previousElementSibling.firstElementChild.focus();
  }

  render() {
    const { dateFormat = 'MM/dd/yyyy', onDayChange, date } = this.props;
    return (
      <React.Fragment>
        <DayPickerInput
          role="dialog"
          aria-modal="true"
          dayPickerProps={{
            todayButton: 'Today',
            localUtils: this,
            className: 'daypickerdaypicker',
            ...this.props,
            styleName: 'daypickerinput',
          }}
          inputProps={{
            className: 'daypickerinput',
          }}
          onDayChange={onDayChange}
          placeholder="Select a Date"
          value={date || null}
          format={dateFormat}
          formatDate={this.formatDate}
          parseDate={this.parseDate}
        />
        <Icon styleName="calendar" name="calendar outline" link color="grey" onClick={this.iconClick} />
      </React.Fragment>
    );
  }
}

export default injectIntl(IntlDatePicker);
